import React, { useState, useEffect, useRef } from "react";
import {
  Flex,
  Popover,
  Skeleton,
  Space,
  Form,
  Row,
  Col,
  Modal,
  Drawer,
  Button,
  Tooltip,
  Spin,
} from "antd";
import Pies from "../../../assets/images/pies.svg";
import SqlImg from "../../../assets/images/sql.svg";
import Fx from "../../../assets/images/fx.svg";
import Sjfx from "../../../assets/images/sjfx.svg";
import Sjjd from "../../../assets/images/sjjd.svg";
import SJly from "../../../assets/images/sjly.svg";
import PieImg from "../../../assets/images/pie.svg";
import ZhuImg from "../../../assets/images/zhu.svg";
import ZxImg from "../../../assets/images/zx.svg";
import TableImg from "../../../assets/images/table.svg";
import SdImg from "../../../assets/images/sd.svg";
import MapImg from "../../../assets/images/map.svg";
import ZbkImg from "../../../assets/images/zbk.svg";
import Dispie from "../../../assets/images/dispie.svg";
import Disline from "../../../assets/images/disline.svg";
import Disbar from "../../../assets/images/disbar.svg";
import Distable from "../../../assets/images/disTable.svg";
import DisSd from "../../../assets/images/dissd.svg";
import DisMap from "../../../assets/images/dismap.svg";
import Diszbk from "../../../assets/images/diszbk.svg";
import GbidownArrow from "../../../assets/images/gbidownArrow.svg";
import "./index.less";
import EchartsData from "./echart";
import QsSqlData from "./qsSql";
import SearchParam from "./searchParm";
import SjjdData from "./sjjd";
import GyfxData from "./gyfx";
import SjlyData from "./sjly";
import { useMessageContext } from "@sui/chat-ui";
import axios from "axios";
import API from "@/api";

function GbiContent(props) {
  const {
    title,
    attributionable,
    interpretationable,
    forecastable,
    filters,
    data,
    default_chart,
    support_charts,
    chart_data,
    question_id,
    drillable,
    drill_actions,
    wide_table_refs,
    root_slots,
    slots,
  } = props;

  /*
   name: field,
   label:fieldName,
   required:required,
   defaultValue: value,
   placeholder: example,
   type:type,
   options:options,
  */
  console.log(props, "我是gbiprops");

  const parseJSONString = (str) => {
    if (typeof str !== "string") {
      return { valid: false, error: "输入必须是字符串", data: null };
    }

    try {
      const data = JSON.parse(str);
      return { valid: true, data: data, error: null };
    } catch (e) {
      return { valid: false, data: null, error: e.message };
    }
  };

  const searchParams = parseJSONString(filters);
  const supportCharts = parseJSONString(support_charts);
  const drillActions = parseJSONString(drill_actions);
  const wideTableRef = parseJSONString(wide_table_refs);
  const rootSlots = parseJSONString(root_slots);
  const slotsData = parseJSONString(slots);
  const [charaData, setCharaData] = useState(
    parseJSONString(chart_data)?.data || {},
  );
  const gyfx = parseJSONString(attributionable);
  const [chatType, setChatType] = useState(default_chart);

  const [qsSqlOpen, setQsSqlOpen] = useState(false);
  const [refresh, setRefresh] = useState("");
  const [reLoading, setReLoading] = useState(false);
  const [refreshXz, setRefreshXz] = useState("");
  const [spinning, setSpinning] = useState(true);

  //数据解读
  const [sjjdOpen, setSjjdOpen] = useState(false);
  //归因分析
  const [gyfxOpen, setGyfxOpen] = useState(false);

  //趋势预测数据
  const [qsycData, setQsycData] = useState({});
  const [clickSjfx, setClickSjfx] = useState(false);

  //数据来源
  const [sjlyOpen, setSjlyOpen] = useState(false);

  const aiData = useMessageContext();
  const searchRef = useRef();

  const refreshData = () => {
    setRefresh(Math.random());
    setReLoading(true);
    setSpinning(true);
  };

  const refreshXzData = () => {
    setRefreshXz(Math.random());
  };
  console.log("aiData", aiData);
  useEffect(() => {
    if (aiData?.data?.data?.data?.isFinished) {
      setSpinning(false);
    }
  }, [aiData]);

  useEffect(() => {
    if (!searchRef) {
      return;
    }
    const data = searchRef?.current?.getValue();
    console.log(data);
    data?.map((item) => {
      if (item.selected && item.selected.length === 0) {
        delete item.selected;
      }
    });
    if (reLoading) {
      axios
        .post(API.getFilterAndNextData, {
          question_id: question_id,
          filters: data,
        })
        .then((res) => {
          console.log(res, "筛选数据");
          const data = res?.data?.chart_data || {};
          setCharaData(data);
          setSpinning(false);
        });
    }
  }, [refresh]);

  const renderImg = () => {
    if (chatType === "table") {
      return <img src={TableImg} />;
    } else if (chatType === "bar") {
      return <img src={ZhuImg} />;
    } else if (chatType === "pie") {
      return <img src={PieImg} />;
    } else if (chatType === "line") {
      return <img src={ZxImg} />;
    } else if (chatType === "map") {
      return <img src={MapImg} />;
    } else if (chatType === "scatter") {
      return <img src={SdImg} />;
    } else if (chatType === "dashboard") {
      return <img src={ZbkImg} />;
    } else {
      return "";
    }
  };

  const changSpining = (val) => {
    setSpinning(val);
  };
  console.log("下钻之后的spinning", spinning);

  useEffect(() => {
    if (clickSjfx) {
      axios
        .post(API.qsyc, {
          question_id: question_id,
        })
        .then((res) => {
          const data = res?.data?.data || [];
          console.log(data);
          setQsycData(data);
        });
    } else {
      setQsycData({});
    }
  }, [clickSjfx]);

  return (
    <div>
      <div className="info">
        <div
          className="title"
          style={{
            maxWidth: `calc(100% - ${
              document.getElementsByClassName("imgs")[0]?.clientWidth + 20
            }px)`,
          }}
        >
          {title ? title + "：" : ""}
        </div>
        {title ? (
          <div className="imgs">
            <Space>
              <div className="imgItem">
                <Popover
                  className="imgPopover"
                  placement="bottomRight"
                  content={
                    <>
                      <div className="imgTitle">图表切换</div>
                      <div className="chooseType">
                        <Row gutter={[16, 16]}>
                          <Col span={8}>
                            {supportCharts?.data?.includes("table") ? (
                              <img
                                src={TableImg}
                                onClick={() => {
                                  setChatType("table");
                                }}
                              />
                            ) : (
                              <img src={Distable} />
                            )}
                            <div className="title">表格</div>
                          </Col>
                          <Col span={8}>
                            {supportCharts?.data?.includes("bar") ? (
                              <img
                                src={ZhuImg}
                                onClick={() => {
                                  setChatType("bar");
                                }}
                              />
                            ) : (
                              <img src={Disbar} />
                            )}
                            <div className="title">柱状图</div>
                          </Col>
                          <Col span={8}>
                            {supportCharts?.data?.includes("pie") ? (
                              <img
                                src={PieImg}
                                onClick={() => {
                                  setChatType("pie");
                                }}
                              />
                            ) : (
                              <img src={Dispie} />
                            )}
                            <div className="title">饼图</div>
                          </Col>

                          <Col span={8}>
                            {supportCharts?.data?.includes("line") ? (
                              <img
                                src={ZxImg}
                                onClick={() => {
                                  setChatType("line");
                                }}
                              />
                            ) : (
                              <img src={Disline} />
                            )}
                            <div className="title">折线图</div>
                          </Col>

                          <Col span={8}>
                            {supportCharts?.data?.includes("map") ? (
                              <img
                                src={MapImg}
                                onClick={() => {
                                  setChatType("map");
                                }}
                              />
                            ) : (
                              <img src={DisMap} />
                            )}
                            <div className="title">地图</div>
                          </Col>

                          <Col span={8}>
                            {supportCharts?.data?.includes("scatter") ? (
                              <img src={SdImg} onClick={() => {
                                setChatType("scatter")
                              }} />
                            ) : (
                              <img src={DisSd} />
                            )}
                            <div className="title">散点图</div>
                          </Col>

                          <Col span={8}>
                            {supportCharts?.data?.includes("dashboard") ? (
                              <img
                                src={ZbkImg}
                                onClick={() => {
                                  setChatType("dashboard");
                                }}
                              />
                            ) : (
                              <img src={Diszbk} />
                            )}
                            <div className="title">指标卡</div>
                          </Col>
                        </Row>
                      </div>
                    </>
                  }
                >
                  <span
                    style={{
                      paddingRight: "10px",
                    }}
                  >
                    {renderImg()}
                  </span>
                  <img src={GbidownArrow} />
                </Popover>
              </div>

              <Tooltip title="取数Sql">
                <div className="imgItem">
                  <img
                    src={SqlImg}
                    onClick={() => {
                      setQsSqlOpen(true);
                    }}
                  />
                </div>
              </Tooltip>
              {attributionable === "true" || attributionable === true ? (
                <Tooltip title="归因分析">
                  <div className="imgItem">
                    <img
                      src={Fx}
                      onClick={() => {
                        setGyfxOpen(true);
                      }}
                    />
                  </div>
                </Tooltip>
              ) : undefined}
              {supportCharts?.data?.includes("line") ? (
                forecastable === "true" || forecastable === true ? (
                  <Tooltip title="趋势预测">
                    <div className="imgItem">
                      <img
                        src={Sjfx}
                        onClick={() => {
                          setClickSjfx((v) => !v);
                        }}
                      />
                    </div>
                  </Tooltip>
                ) : undefined
              ) : undefined}

              {interpretationable === "true" || interpretationable === true ? (
                <Tooltip title="数据解读">
                  <div className="imgItem">
                    <img
                      src={Sjjd}
                      onClick={() => {
                        setSjjdOpen(true);
                      }}
                    />
                  </div>
                </Tooltip>
              ) : undefined}

              <Tooltip title="数据来源">
                <div className="imgItem">
                  <img
                    src={SJly}
                    onClick={() => {
                      setSjlyOpen(true);
                    }}
                  />
                </div>
              </Tooltip>
            </Space>
          </div>
        ) : undefined}
      </div>
      {/* {drillable === "true" || drillable === true ? (
        <div className="drillable">点击维度可下钻</div>
      ) : undefined} */}

      {searchParams?.data && searchParams?.data.length ? (
        <>
          <div className="filters">
            <SearchParam
              filters={searchParams?.data}
              ref={searchRef}
              refreshData={() => {
                refreshData();
              }}
            />
          </div>
        </>
      ) : undefined}

      <div className="gbiContent">
        <Spin spinning={spinning}>
          <EchartsData
            type={chatType}
            data={charaData}
            drillable={drillable}
            refreshData={() => {
              refreshXzData();
            }}
            changSpining={(val) => {
              changSpining(val);
            }}
            qsycData={qsycData}
            question_id={question_id}
            drillActions={drillActions?.data}
          />
        </Spin>
      </div>
      <Modal
        className="qssqlModal"
        title="查看取数SQL"
        open={qsSqlOpen}
        onCancel={() => {
          setQsSqlOpen(false);
        }}
        destroyOnHidden
        width={"800px"}
        footer={
          null
          // <>
          //   <Button
          //     onClick={() => {
          //       setQsSqlOpen(false);
          //     }}
          //   >
          //     关闭
          //   </Button>
          // </>
        }
      >
        <QsSqlData data={aiData} />
      </Modal>
      <Drawer
        title="数据解读"
        destroyOnHidden
        onClose={() => {
          setSjjdOpen(false);
        }}
        rootStyle={{
          top: 60, // 1. 强制将抽屉整体向下推移 Banner 的高度
          height: `calc(100vh - ${60}px)`, // 2. 限制高度，减去 Banner 的高度
          overflow: "hidden", // 可选：防止内部滚动条影响布局
        }}
        open={sjjdOpen}
        width={"50%"}
        footer={
          null
          // <>
          //   <Button
          //     onClick={() => {
          //       setSjjdOpen(false);
          //     }}
          //   >
          //     关闭
          //   </Button>
          // </>
        }
        styles={{
          body: {
            background: "#f2f2f2",
          },
          mask: {
            // 假设左侧菜单栏宽度为 200px
            left: window.innerWidth < 1200 ? 249 : 259,
            // 遮罩宽度 = 100% - 左侧菜单宽度
            width:
              window.innerWidth < 1200
                ? "calc(100% - 239px)"
                : "calc(100% - 259px)",
          },
        }}
      >
        <SjjdData question_id={question_id} title={title} />
      </Drawer>
      <Drawer
        title="归因分析"
        open={gyfxOpen}
        destroyOnHidden
        onClose={() => {
          setGyfxOpen(false);
        }}
        width={"50%"}
        rootStyle={{
          top: 60, // 1. 强制将抽屉整体向下推移 Banner 的高度
          height: `calc(100vh - ${60}px)`, // 2. 限制高度，减去 Banner 的高度
          overflow: "hidden", // 可选：防止内部滚动条影响布局
        }}
        footer={
          null
          // <>
          //   <Button
          //     onClick={() => {
          //       setSjjdOpen(false);
          //     }}
          //   >
          //     关闭
          //   </Button>
          // </>
        }
        styles={{
          body: {
            background: "#f2f2f2",
          },
          mask: {
            // 假设左侧菜单栏宽度为 200px
            left: window.innerWidth < 1200 ? 249 : 259,
            // 遮罩宽度 = 100% - 左侧菜单宽度
            width:
              window.innerWidth < 1200
                ? "calc(100% - 239px)"
                : "calc(100% - 259px)",
          },
        }}
      >
        <GyfxData
          question_id={question_id}
          wideTableRef={wideTableRef?.data}
          rootSlots={rootSlots?.data}
          slots={slotsData?.data}
        />
      </Drawer>
      <Drawer
        title="数据来源"
        open={sjlyOpen}
        onClose={() => {
          setSjlyOpen(false);
        }}
        destroyOnHidden
        width={"50%"}
        rootStyle={{
          top: 60, // 1. 强制将抽屉整体向下推移 Banner 的高度
          height: `calc(100vh - ${60}px)`, // 2. 限制高度，减去 Banner 的高度
          overflow: "hidden", // 可选：防止内部滚动条影响布局
        }}
        styles={{
          body: {
            background: "#f2f2f2",
            padding:"12px"
          },
          mask: {
            // 假设左侧菜单栏宽度为 200px
            left: window.innerWidth < 1200 ? 249 : 259,
            // 遮罩宽度 = 100% - 左侧菜单宽度
            width:
              window.innerWidth < 1200
                ? "calc(100% - 239px)"
                : "calc(100% - 259px)",
          },
        }}
        footer={null}
      >
        <SjlyData question_id={question_id} />
      </Drawer>
    </div>
  );
}

export default GbiContent;
